const OrganizationType = {
    SUPPLIER: 'supplier',
    CUSTOMER: 'customer',
    INTERNAL: 'internal',
};

const CommunicationType = {
    POST_ADDRESS: 'post_address',
    EMAIL: 'email',
    PHONE: 'phone',

    toArray() {
        return [
            this.EMAIL,
            this.POST_ADDRESS,
            this.PHONE
        ];
    }
};

export {
    OrganizationType,
    CommunicationType
}
